import React from 'react'
import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import Navbar from "./Navbar";
import Header from "./Header";
import Footer from "./Footer";
import BoardPending from './container/BoardPending';
function PendingVerification() {
    const location = useLocation();

    useEffect(() => {
        const menuToggle = document.getElementById("sidebar-hide");
        const sidebar = document.querySelector(".pc-sidebar");
        if (!menuToggle) return;

        const toggleSidebar = () => {
            sidebar.classList.toggle("pc-sidebar-hide");
        };

        menuToggle.addEventListener("click", toggleSidebar);

        return () => {
            menuToggle.removeEventListener("click", toggleSidebar);
        };
    }, [location.pathname]);
    return (
        <div>
            <Navbar />
            <Header />
            <BoardPending />
            <Footer />
        </div>
    )
}

export default PendingVerification